import t from '@instructure/quiz-i18n/es/format-message';
export var checkIsBreach = function checkIsBreach(firstEventData, currentEventData) {
  var result = {
    isBreach: false
  };
  var checks = [{
    key: 'ipAddress',
    message: t('Client IP address is different from initial address')
  }, {
    key: 'browserSessionID',
    message: t('Browser session ID is different from initial id')
  }, {
    key: 'browserString',
    message: t('Browser is different from initial browser')
  }, {
    key: 'userPlatform',
    message: t('Operating system is different from initial system')
  }];
  checks.forEach(function (_ref) {
    var key = _ref.key,
      message = _ref.message;
    if (currentEventData[key] !== firstEventData[key]) {
      result.isBreach = true;
      result[key] = message;
    }
  });
  return result;
};